const sv = {
  grannbox_onboarding: {
    login_header: "Logga in på ihopa",
    login_subheader: "Efter att ha loggat in på ditt konto kommer du att omdirigeras till vår betalningssida.",
    forgot_pass_header: "Återställ lösenord",
    forgot_pass_subheader: "Lägg till din ihopa-e-post så skickar vi en länk för återställning av lösenord till dig.",
    create_account_header: "Skapa konto",
    create_account_subheader: "Efter att du skapat ditt ihopa-konto kommer du att omdirigeras till vår betalningssida.",
    login_continue: "Logga in och fortsätt",
    back_to_login: "Tillbaka till login",
    new_to_ihopa: "Ny på ihopa? Skapa konto",
    already_have_account: "Har ett konto? Logga in",
    why_phone: "Vi behöver kunna skicka dig sms",
    why_address: "För att ge dig rätt produkturval",
    continue: "Fortsätt",
    phone_number: "Telefonnummer",
  },
  menu: {
    home: "Hem",
    how_it_works: "Hur det funkar",
    why_co_own: "Varför är detta bra?",
    about_us: "Om oss",
    sign_up: "Registrera dig",
    login: "Logga in",
    logout: "Logga ut",
    dashboard: "Mina produkter",
    account: "Mitt konto",
    messages: "Meddelanden",
    notifications: "Notifieringar",
    my_circles: "Mina produkter",
    dont_have_account: "Har du inget konto?",
    forgot_password: "Glömt ditt lösenord?",
    register_here: "Registrera dig här",
    recover_password: "Återställ lösenord",
    terms_of_use: "Användarvillkor",
    privacy_policy: "Personuppgiftspolicy",
    partners: "Våra partners",
    ihopa_for_business: "Ihopa för ditt företag",
    press: "Press",
  },
  why_co_own: {
    cta: "Sätt igång",
    our_partners: "Våra partners",
  },
  sign_up: {
    title: "Registrera dig",
    read_and_accept: "Jag har läst och godkänner",
    register: "Skapa konto",
    login_here: "Logga in här",
    have_account: "Har du redan ett konto?",
    next_step: "Nästa steg",
    placeholders: {
      email_address: "Emailadress",
      first_name: "Förnamn",
      last_name: "Efternamn",
      password: "Lösenord",
    },
  },
  login: {
    title: "Logga in",
    placeholders: {
      email_address: "Emailadress",
      password: "Lösenord",
    },
  },
  cookie_conset: {
    message:
      "Ihopa.com använder så kallade cookies, vilket är en liten textfil som lagras på den enhet som du surfar med. Syftet är dels att förbättra din användarupplevelse, såsom att förkorta laddningstider och att anpassa innehållet för dig. Dessutom används cookies för att mäta trafiken på vår webbplats, för insamling av statistik och för att öka förståelsen för hur vi kan förbättra webbplatsen. Slutligen används cookies för att underlätta användaridentifiering. Vi använder både egna cookies och cookies från tredje part såsom google. Dessa kan både vara av beständig och av temporär sort, där den senare inte sparas på din enhet efter ditt besök. Genom att använda våra tjänster godkänner du att vi använder cookies, såvida du inte har inaktiverat dessa i inställningar för din webbläsare.",
    button: "Jag förstår",
  },
  home: {
    hero: {
      how_it_works: "Hur det funkar",
      learn_more: "Läs mer",
    },
    co_buy: {
      button_text: "Sätt igång",
    },
    prylpoolen: {
      button_text: "Gå till grannboxen",
    },
    circle_collection: {
      heading: "Produkter",
      subheading: "Fler produkter.",
    },
    circle_suggestions: {
      heading: "Förslag",
      subheading: "Här kommer lite inspiration.",
    },
    trustpilot_rating: "Vi har omdömet 4,8 av 5",
    havent_found_heading: "Konsumera smartare",
    havent_found_subheading: "Vi gör det enkelt och säkert",
    request_circle: {
      heading: "Berätta vad du behöver",
      sub_heading: "Så kanske vi kan hjälpa till",
      button: "Jag behöver",
    },
    ready_to_co_own: {
      heading: "Redo att ta klivet?",
      sub_heading: "Det här är det smarta sättet att konsumera.",
      button: "Kom igång",
      faq_button: "Läs FAQs",
    },
  },
  circle: {
    per_month: "Per månad",
    circle_creator: "Gruppskapare",
    start_co_owning: "Skicka förfrågan",
    commitment_info:
      "Att skicka en förfrågan är inte bindande. När du blivit godkänd kan du chatta med gruppen, se delägaravtalet och komma fram till om förutsättningarna är bra nog för att gå vidare till ett köp.",
    per_person: "Per person",
    location: "Plats",
    spot_left: "Andelar kvar",
    ready_to_co_own: "Sugen?",
    co_owners: "Medlemmar",
    lets_start: "Sätt igång!",
    in: " i ",
    white_monday_join: "Gå med",
  },
  circle_members: {
    heading: "Gruppmedlemmar",
    circle_creator: "Gruppledare",
    circle_member1: "Gick med ",
    circle_member2: " dagar sedan ",
    make_admin: "Ge adminrättigheter",
    kick_user: "Uteslut medlem",
    migrate_members: "Migrate members to this circle",
    copy_members: "Copy members",
    source_circle: "Source circle guid",
  },
  member_requests: {
    accept: "Godkänn",
    reject: "Neka",
    pending_request: "Förfrågningar",
  },
  new_circle: {
    create: "Skapa",
    heading: "Skapa en grupp",
    subheading: "Pejla intresset med dina vänner, dela på sociala medier",
    create_a_circle: "Skapa en grupp",
    did_not_find: "Hittade du inte det du sökte?",
    did_not_find_description: "Sörj inte, skapa en produktgrupp själv så kan andra ansluta till den istället.",
    public_circle_switch: "Synlig för alla",
    pre_owned_switch: "Redan inköpt produkt",
    agreement_switch: "Lägg till ett delägaravtal till gruppen",
    public_circle_title: "Vad innebär synlig för alla",
    pre_owned_title: "Vad innebär en redan inköpt produkt",
    agreement_title: "Vad är ett delägaravtal?",
    public_circle_explain:
      "Synlig för alla innebär att tills den är full så kan alla se den. På så vis maximerar du chansen att den blir komplett. Oroa dig inte, du kan alltid neka förfrågningar om att gå med.",
    pre_owned_explain: "Att du eller en grupp redan äger den",
    agreement_explain:
      "Om 2 eller flera personer äger något tillsammans är det smart att ha ett delägaravtal som reglerar samarbetet. Framför allt om det är något större såsom en båt så är det mycket bra att ha ett avtal på plats. ihopa hjälper gärna till och modifierar avtalet om ni vill det. ",
    create_circle_button: "Skapa din grupp",
    edit_circle_button: "Uppdatera grupp",
    preview_agreement_button: "Förhandsgranska delägaravtalet",
    is_prylpoolen_switch: "Is Prylpoolen",
    is_prylpoolen_title: "Is prylpoolen title",
    is_prylpoolen_explain: "Is prylpoolen explain",
    booking_limitations_title: "Bokningsbegränsningar",
    booking_limitations_explain: "Här kan du aktivera begränsningar för hur varje medlem får boka.",
    unlimited: "Obegränsat",
    labels: {
      add_product_image: "Lägg till produktbild",
      product_name: "Produktnamn",
      product_category: "Produktkategori",
      product_price: "Produktpris",
      product_url: "Produktlänk",
      description: "Skriv något som kan vara relevant för andra intresserade",
      number_of_owners: "Antal medlemmar",
      max_active_bookings: "Max antal aktiva bokningar",
      max_booking_duration: "Max bokningslängd",
      circle_status: "Circle status",
      door_id: "Door ID",
      door_indications: "Door indications",
      door_indications_heading: "Door indications heading",
      door_indications_paragraph_1: "Door indications paragraph 1",
      door_indications_paragraph_2: "Door indications paragraph 2",
      door_indications_image_url: "Door indications image url",
      rentable_switch: "Is rentable",
      rental_pricing_tier: "Rental pricing tier",
    },
    placeholders: {
      paste_image_url: "Eller klistra in en produktbildslänk (frivilligt)",
      product_name_suggestion: "GoPro 6",
      select_category: "Välj en kategori",
      add_price: "Pris",
      url_suggestion: "https://domain.com/product",
      description_placeholder: "Var kreativ 😃",
      door_id: "Door ID",
      door_indications: "Door indications",
      door_indications_heading: "Door indications heading",
      door_indications_paragraph_1: "Door indications paragraph 1",
      door_indications_paragraph_2: "Door indications paragraph 2",
      door_indications_image_url: "Door indications image url",
      rentable_switch: "Is rentable",
      rental_pricing_tier: "Rental pricing tier",
    },
  },
  new_expense: {
    placeholders: {
      expense: "Beskriv ditt utlägg...",
      price: "SEK",
    },
  },
  new_usage_log: {
    placeholders: {
      description: "Beskriv användningen",
      value: "Antal",
      unit: "Enhet",
    },
    options: {
      km: "km",
      hrs: "timmar",
      min: "minuter",
    },
  },
  circle_admin: {
    members: "Delägare",
    per_person: "Per person",
    location: "Plats",
    paragraph1: "Gruppen behöver ",
    paragraph2: " fler medlemmar. Bjud in vänner",
    share_button: "Kopiera länk",
    share_button_facebook: "Dela",
    sign_agreement_notification: "Godkänn delägaravtalet",
    wait_others_sign_agreement: "Nu väntar vi på att de andra ska godkänna avtalet",
    wait_for_purchase: "Nu väntar vi på att inköpet ska genomföras",
    admin_purchase_item: "Nu kan du göra inköpet",
    purchase_button: "Inköpet är klart",
    sign: "Godkänn",
    already_signed: "har redan godkänt avtalet. Du behöver också göra det.",
    copied_to_clipboard: "Länk kopierad och går nu att klistra in i mail eller sms etc",
    share_on_facebook: "Tipsa om ditt initiativ",
  },
  circle_status: {
    member_gathering: "Inväntar leverans",
    awaiting_purchase: "Inväntar leverans",
    progress: "Pågående",
    pending: "Väntar",
    awaiting_commitment: "Inväntar godkännande",
    completed: "Komplett",
  },
  public_profile: {
    profile: "s profil",
    send_message: "Skicka meddelande",
    about: "Om ",
    location: "Adress",
    member_since: "Medlem sedan ",
    user_circles: "s produkter",
    not_in_circles:
      "Visste du att en borrmaskin används 13 minuter under dess livstid i genomsnitt. Den räcker för fler!",
    create_circle_with_him: "Skapa en grupp",
    create_circle: "Skapa en grupp",
    sidebar_right_heading: "Produkter",
  },
  user_details: {
    member_since: "Medlem sedan",
    save_profile: "Spara profil",
    public_profile: "Offentlig profil",
    labels: {
      first_name: "Förnamn",
      last_name: "Efternamn",
      email: "Email",
      location: "Din adress",
      description: "Något kort om dig själv",
      change_password: "Ändra lösenord",
      confirm_password: "Bekräfta lösenord",
    },
    placeholders: {
      first_name: "John",
      last_name: "Doe",
      email: "john.doe@domain.com",
      location: "Adress",
      description: "Börja skriv...",
      change_password: "Lämna tomt för nuvarande",
      confirm_password: "Lämna tomt för nuvarande",
      mobile_phone: "Tel +46...",
    },
  },
  user_activation_banner: {
    heading: "Du behöver aktivera ditt konto!",
    resend_activation_email: "Skicka aktiveringslänk igen",
    paragraph1: "Vi skickade dig en aktiveringslänk på email ",
    paragraph2: " Har du ännu inte fått den?",
  },
  collection_page: {
    owners_suggested: "Lämpligt antal delägare",
    heading: "Suggestions: skapa din egen grupp",
    subheading: "Saknar du inspiration? Här kommer handplockade förslag.",
    opened_circles_heading: "Öppna grupper",
    opened_circles_subheading: "Anslut till grupper skapade av andra",
  },
  recover_password: {
    heading: "Återställ lösenord",
    button: "Återställ lösenord",
    email_placeholder: "Email",
  },
  reset_password: {
    change_password: "Ändra lösenord",
    button: "Ändra lösenord",
    password_placeholder: "Lösenord",
    password_repeat_placeholder: "Upprepa lösenord",
  },
  suggestion: {
    per_person: "Per person",
  },
  general_messages: {
    no_circles: "Inga produkter här",
    load_more: "Ladda flera",
    send_request: "Skicka förfrågan",
    find_match: "Låt oss matcha ihop dig",
  },
  google_maps_modal: {
    title: "Produktens förvaringsplats",
    save_location: "Spara positionen",
  },
  profile_completeness: {
    heading: "Profilens styrka: ",
    subheading: "En stark profil ger fördelar",
    add_avatar: "Lägg till en profilbild",
    add_address: "Lägg till din adress",
    about_you: "Skriv något om dig själv",
  },
  booking: {
    select_period: "Välj ditt bokningsintervall.",
    days_booked: " dagar bokade",
    overlapping_interval: "Överlappande bokningar",
    cancel_booking: "Ta bort bokning",
    user_booking: "Bokning",
    save_booking: "Spara bokning",
    start_date: "Startdatum",
    end_date: "Slutdatum",
    existing_bookings: "Befintliga bokningar",
    subscription: "Prenumeration",
  },
  expenses: {
    user: "Delägare",
    spent: "Spenderade",
    ago: " sedan",
    total_spent: " i totala utlägg tills nu",
  },
  messaging: {
    title: "Meddelanden",
    new_message_button: "Nytt meddelande",
    messages_inside_circles_label: "Meddelanden inom grupper",
    personal_messages_label: "Direktmeddelande",
  },
  notifications: {
    title: "Notifieringar",
    no_notifications: "Inga nya notifieringar",
    setup_circle: "Vill du skapa din första produktgrupp",
    create_circle: "Skapa grupp",
  },
  request_circle: {
    labels: {
      description: "Gruppbeskrivning",
    },
    placeholders: {
      description: "Beskriv vad du vill ha",
    },
  },
  my_circles: {
    heading: "Mina produkter",
    create_circle: "Skapa en grupp",
    circles_near_you: "Produkter nära dig",
    you_have_no_circles: "Du har inga produkter ännu",
    setup_new_circle: "Starta en grupp nu direkt.",
  },
  errors: {
    commitment: {
      fetch: "Kan inte hämta alla avtalsgodkännanden.",
      sign: "Avtalsgodkännande lyckades inte. Testa igen.",
    },
    login: {
      invalid_email: "Ogiltig emailadress",
      password_required: "Lösenord krävs",
    },
    register: {
      invalid_email: "Felaktig emailadress",
      invalid_first_name: "Förnamn krävs",
      invalid_last_name: "Efternamn krävs",
      password_to_short: "Lösenordet är för kort. Minimum 6 tecken.",
      accept_terms: "Läs villkoren och godkänn dem.",
    },
    circle_collection: {
      fetch: "Kan inte hämta gruppkategorierna",
      unhandled: "Något blev fel med gruppkategorierna",
    },
    circle_suggestions: {
      fetch: "Kan inte hämta gruppförslag",
      unhandled: "något blev fel med gruppförslagen",
    },
    iam: {
      login: "Felaktigt användarnamn eller lösenord",
      register: "Det gick inte att skapa kontot. Testa igen senare.",
      register_duplicated: "Registreringsfel. Mailadressen används redan.",
      session_expired: "Du loggades ut pga inaktivitet",
    },
    users: {
      fetch: "Det går inte att hämta profilen",
      update: "Det gick inte att uppdatera profilen",
      error_on_reset_password: "Det gick inte att ändra lösenordet",
      resend_activation_email: "Det gick inte att skicka återställningsmail",
    },
    update_user_details: {
      description: "Skriv något kort om dig själv",
      passwords_not_matching: "Lösenorden matchar inte",
      error_on_activate_account: "Det blev något fel med aktivering via mail",
    },
    new_circle: {
      valid_url: "Lägg till en fungerande produktlänk",
      product_name: "Lägg till ett produktnamn",
      description: "Beskriv produkten",
      add_product_price: "Lägg till priset för produkten",
      add_product_image: "Lägg till en produktbild",
      add_location: "Lägg till en plats för produkten, dvs där den ska förvaras",
      image_to_big: "Bilden får inte vara större än 3MB. Testa med en annan bild.",
    },
    save_circle: {
      error_on_save: "Det gick inte att spara. Testa igen.",
    },
    member_requests: {
      fetch: "Det gick inte att hämta gruppförfrågningar",
      update: "Det gick inte att uppdatera gruppförfrågningar",
      already_member: "Du är redan en medlem",
      already_send_join_request: "Du har redan skickat en förfrågan till den här gruppen",
      join_request:
        "Det gick inte att skicka förfrågan till gruppen. Testa igen och hör gärna av dig till oss om det ändå inte funkar.",
    },
    my_circles: {
      fetch: "Det gick inte att hämta dina produkter.",
      mark: "Det gick inte att markera köpet som genomfört",
      migrate: "Error on migrating users",
    },
    bookings: {
      fetch: "Det gick inte att hämta dina bokningar",
      add_booking: "Det gick inte att lägga bokningen. Testa igen.",
      MaxBookingDurationExceeded: "Så lång bokning är inte tillåtet. Minska längden på bokningen och försök igen.",
      MaxActiveBookingsExceeded:
        "Bokningen går inte att lägga eftersom du har slagit i taket på tillåtet antal aktiva bokningar.",
    },
    expenses: {
      fetch: "Det gick inte att hämta utläggsloggen",
      register_expense: "Det gick inte att lägga in utlägget",
      add_booking: "Fel vid registrering av utlägg, testa igen.",
      add_price: "Fyll i beloppet. ",
      add_expense: "Fyll i detaljer om utlägget.",
    },
    usage_logs: {
      fetch: "Det blev något fel vid hämtning av användningsloggen",
      register_usage: "Fel vid registrerande av användning",
      add_usage_description: "Lägg till detaljer om din användning",
      add_value: "Lägg till ett antal",
      add_unit: "Lägg till en enhet",
    },
    request_circle: {
      description: "Beskriv vad du tänker dig",
    },
    prypool_products: {
      fetch: "Det gick inte att hämta dina produkter",
    },
    sharing_box: {
      checkout_session: "Något gick fel på Stripe, testa gärna igen.",
    },
    rental_session: {
      fetch: "Något gick fel på Stripe, testa gärna igen.",
    }
  },
  success: {
    commitment: {
      sign: "Ditt godkännande har registrerats.",
    },
    iam: {
      login: "Du är nu inloggad",
      register: "Kontot har nu skapats. Kolla efter mailet med din aktiveringslänk.",
    },
    update_user_details: {
      successfully_saved: "Dina ändringar har sparats",
      successfully_changed_password: "Ditt lösenord har ändrats",
      recover_email_send: "Vi har skickat ett email med en återställningslänk för lösenordet.",
      successfully_activated_account: "Ditt konto har blivit aktiverat",
      resend_activation_email: "Vi har skickat ett mail med ny aktiveringslänk.",
    },
    save_circle: {
      successfully_saved: "Gruppen har uppdaterats",
    },
    member_requests: {
      update: "Förfrågan har besvarats",
      join_request: "Din förfrågan om att ansluta till gruppen har skickats.",
    },
    bookings: {
      add_booking: "Din bokning har registrerats",
      delete_booking: "Din bokning har raderats",
    },
    expenses: {
      add_expense: "Ditt utlägg har registrerats",
      delete_expense: "Ditt utlägg har raderats",
    },
    usage_logs: {
      add_usage: "Ditt användande har registrats",
      delete_usage_log: "Din registrering har raderats",
    },
    circle_request: {
      send_request: "Din förfrågan har skickats",
    },
    my_circles: {
      migrate: "Members successfully migrated",
    },
  },
  messages: {
    title: "Inga meddelanden än",
    description: "Du behöver vara medlem i en grupp för att kunna chatta med andra användare",
    write_first_message: "Skriv något för att påbörja chatten",
    create_circle: "Skapa din första grupp",
    message_input_placeholder: "Börja skriv ditt meddelande...",
  },
  admin_tabs: {
    log: "Användningslogg",
    chat: "Chatt",
    booking: "Bokning",
    expenses: "Utlägg",
    agreement: "Avtal",
  },
  agreement: {
    and: "och",
  },
  agreement_modal: {
    title: "Avtal",
  },
  circle_form: { create_circle: "Grupp" },
  cookie_banner: "Den här webbsidan använder s k kakor. Lär mer i personuppgiftspolicyn",
  i_understand: "Jag godkänner",
  password_score: {
    too_short: "för kort",
    weak: "svagt",
    okay: "mediokert",
    good: "bra",
    strong: "starkt",
    stronger: "mycket starkt",
  },
  custom_landing: {
    landing_automower: {
      buy_with_neighbours: "Köp med grannen",
      learn_more: "Så funkar ihopa",
      in_collaboration: "I samarbete med",
    },
    landing_othergardening: {
      buy_with_neighbours: "Skapa ett initiativ (ej bindande)",
      sell_share: "Sälj andel av ditt verktyg",
      in_collaboration: "I samarbete med",
    },
    landing_existing_owner: {
      start_sharing: "Kom igång",
      get_started: "Använd samarbetsverktygen",
      sell_part_post_boat: "Lägg upp båtannons",
      sell_part_get_started: "Kom igång",
      post_boat_free: "Lägg upp din båt gratis",
      selling_points_header: "Varför använda ihopa?",
      selling_points_safe_sharing: "Säkert",
      selling_points_safe_sharing_content: "Delägaravtal och försäkring",
      selling_points_easy_sharing: "Enkelt",
      selling_points_easy_sharing_content: "Bokningskalender, utlägg, loggar...",
      selling_points_post_free: "Annonsera om din båt gratis",
      selling_points_post_free_content: "Och hitta andra lämpliga delägare",
    },
    landing_buy_boat: {
      buy_boat: "Köp en andelsbåt med vänner",
      buy_existing: "Köp in dig i en båt",
    },
    landing_cool_stuff: {
      start_circle: "Skapa grupp",
      browse_circles: "Sök existerande grupper",
    },
  },
  whitemonday: {
    landing_whitemonday: {
      create_gift: "Spapa din gåva",
      learn_more: "Läs mer",
      not_sure: "Vad är ihopa?",
      people: "Läs här",
    },
    puzzle_gift: {
      title: "Beställ gåvopussel",
      header: "Beställ gåvopussel",
      subheading: "Beställ ett pussel med bilden på din produkt. Helt gratis.",
      form_header: "Var ska vi skicka pusslet?",
      form_p1:
        "Här kan du beställa ditt gåvopussel. Det blir utformat så att varje person får en pusselbit var som gåvobevis. Det är helt gratis och inga dolda avgifter:",
      form_p2_1: "- Vi kommer att använda din bild eller liknande illustration.",
      form_p2_2: "- Vi skickar det till din adress inom en vecka",
      form_p3:
        "Vänta inte för länge - beställningar lagda efter lucia kan bli försenade pga att posten går på knäna då.",
      form_p4_1: "Om du har frågor är du välkommen att",
      form_p4_2: " kontakta oss",
      send_order: "Skicka beställning",
    },
    placeholders: {
      address: "Din adress",
      name: "För- och efternamn",
    },
    errors: {
      send_puzzle_form: {
        name: "Fyll i ditt för- och efternamn",
        location: "Fyll i din adress",
        send_request_error: "Det blev något fel! Testa igen.",
      },
    },
    success: {
      request_puzzle: {
        success: "Din beställning skickades",
      },
    },
    print_gift_card: {
      title: "Skriv ut gåvobeviset",
      header: "Skriv ut gåvobeviset",
      subheading: "Skriv ut ett gåvobevis så du har något att överlämna.",
      print_card: "Skriv ut gåvobeviset",
      give_part: "vill ge dig en andel som present. Det innebär att ni delar användandet. #WhiteMonday",
    },
  },
  b2b: {
    go_back: "Gå tillbaka",
    create_group: "Påbörja grupp",
    buy_with_friends: "Köp tillsammans",
    use_together: "Köp &amp; använd tillsammans",
    mark_your_interest: "Markera ditt intresse",
    share_your_group: "Sprid din grupp",
    select_owners_number: "Välj antal delägare",
    co_owners: "Delägare",
    per_owner: "Per delägare",
    build_group: "Bilda en grupp",
    buy_together: "Köp tillsammans",
    enjoy_together: "Dela användandet",
    non_binding: "Det är inte bindande att skapa en grupp",
    setup_group: "Påbörja en grupp",
    take_me_back: "Bara ta mig tillbaka",
    invite_your_friends: "Bjud in dina vänner",
    match_with_people: "eller låt dig matchas",
    sharing_agreement: "Delägaravtal",
    group_insurance: "Gruppförsäkring",
    booking_calendar: "Bokningskalender",
    group_chat: "Gruppchatt",
    expense_sharing: "Utläggsredovisning",
    maintenance_logs: "Underhåll och andra loggar",
    what_kind_of_group: "Vad för sorts grupp?",
    what_kind_of_group_note:
      "Notera: Att skapa eller gå med i en grupp är inte bindande förrän ni ingår delägaravtalet.",
    start_friend_group: "Skapa en vän-gruppp",
    start_friend_group_copy: "Gruppen är privat och du kan bjuda in till den.",
    start_public_group: "Skapa en publik grupp",
    start_public_group_copy: "Folk kan hitta den och fråga om att få gå med.",
    send_invites: "Valfritt: bjud in vänner",
    share_group: "Dela länken via dina egna kanaler",
    interested_not_ready: "Intresserad men inte redo?",
    interested_not_ready_copy:
      "Indikera ditt intresse så hör vi av oss om vi ser att någon annan i ditt område skapar en grupp för den här produkten.",
    members_no_helper: "%{members_no} Delägare, ",
    change_members_no: " per person. Klicka för att ändra",
    add_new_friend: "Lägg till vän",
    phone: "Tel:",
    invalid_phone_number: "Ogiltigt nummer",
    mark_interest_an_close: "Spara &amp; ta mig tillbaka",
    add_location: "Lägg till din plats",
    share_step_copy: "Din grupp har skapats och du kan nu dela den med vänner eller på sociala medier.",
  },
  no_image: "Ingen bild tillagd",
  minute: "Minut",
  hour: "Timme",
  day: "Dag",
  week: "Vecka",
  minutes: "Minuter",
  hours: "Timmar",
  days: "Dagar",
  weeks: "Veckor",
  prypool: {
    bundle_products: "Produkter",
    unavailable_products: "Ej tillgängliga produkter",
    available_products: "Tillgängliga produkter",
    checkout: "Hämta ut",
    thank_for_using: "Snyggt - njut av användningen",
    back: "Gå tillbaka",
    transaction_successful: "Betalning lyckades och därmed vill vi varmt välkomna dig som medlem i ihopa Grannbox!",
    success_messages1:
      "Du har nu fått ett email från <a href='mailto:info@ihopa.com'>info@ihopa.com</a> med viktiga instruktioner samt länk till att välja lösenord så att du kan komma igång och boka produkterna. Om du inte hittar emailet, titta i din spam-folder och om det hamnat där, markera att det inte är spam så du får mail i fortsättningen.",
    success_messages2: "Stort tack.",
    price: "Pris %{price}/MÅNAD",
    price_month: "%{price}/MÅNAD",
    address: "ADRESS",
    get_access: "FÅ TILLGÅNG NU",
  },
  rental: {
    rental_price: "Uthyrningspris: ",
    transaction_successful: "Du har nu hyrt denna produkt. Vänligen ladda ner mobilappen för att få tillgång till den.",
    rental: "Uthyrning",
    download_on_app_store: "Ladda ner på App Store",
    download_on_google_play: "Ladda ner på Google Play"
  }
};

export default sv;
